import React from "react";
import { useStyles } from '../styles/CodeJamCreateBlockJamProject.styles';
import { useStyles as useGeneralStyles } from '../styles/CodeJamModal.styles';

import Typography from "@material-ui/core/Typography";
import TextCustomButton from "@/components/text-button/text-button";

import image from "@/images/ide/blockJam-create.svg";
import {AppRoutes} from "@/constants";

const CodeJamCreateBlockJamProject = ({ onClick }) => {
  const classes = useStyles();
  const generalClasses = useGeneralStyles();

  return <>
    <Typography className={generalClasses.tabElementHeader}>Start with a blank project?</Typography>
    <div className={classes.content}>
      <div>
        <div>Open the <b>Playground</b> and create your own project.</div>
      </div>
      <div className={classes.logo}>
        <img
          alt="Drag and drop code blocks to bring your ideas to life."
          className={classes.codeJamLogo}
          src={image}
        />
      </div>
    </div>
    <div className={classes.controls}>
      <TextCustomButton
        onClick={() => {onClick(`${AppRoutes.BLOCK_JAM}/playground`)}}
        className={classes.viewBtnIDE}
        type="submit"
        mode="ide"
        label="Build Now">
      </TextCustomButton>
    </div>
  </>
}

export default CodeJamCreateBlockJamProject;
